import { ITelegramIdsProps } from '../../../../services/TelegramIdsService/types';
import ModalComponent from '../../../../components/ModalComponent';
import zod from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { TelegramIdFormSchema } from '../../../../services/TelegramIdsService/schemas';
import {
  useCreateTelegramId,
  useUpdateTelegramId,
} from '../../../../services/TelegramIdsService/hooks/useMutation';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import ButtonComponent from '../../../../components/ButtonComponent';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../../../context/AppContextProvider';

interface ITelegramIdEditionModal {
  selectedItem?: ITelegramIdsProps;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleForm: () => void;
}

type TelegramIdEditionFormInput = zod.infer<typeof TelegramIdFormSchema>;

const TelegramIdEditionModal = ({
  selectedItem,
  handleForm,
  isOpen,
  setIsOpen,
}: ITelegramIdEditionModal) => {
  const { showSnackbar } = useContext(AppContext);
  const { control, reset, handleSubmit } = useForm<TelegramIdEditionFormInput>({
    resolver: zodResolver(TelegramIdFormSchema),
    defaultValues: {
      id: undefined,
      name: '',
      telegramId: '',
    },
  });
  const { mutateAsync: mutateCreateTelegramId, isLoading: isLoadingCreate } =
    useCreateTelegramId();
  const { mutateAsync: mutateUpdateTelegramId, isLoading: isLoadingUpdate } =
    useUpdateTelegramId();

  const handleClose = () => {
    setIsOpen(false);
    reset();
  };

  const handleEdition = (data: TelegramIdEditionFormInput) => {
    if (selectedItem?.id) {
      mutateUpdateTelegramId({ id: selectedItem.id, data: data }).then(() => {
        resetAndShowMessage('Contato do Telegram atualizado com sucesso!');
      });
    } else {
      mutateCreateTelegramId(data).then(() => {
        resetAndShowMessage('Contato do Telegram criado com sucesso!');
      });
    }
  };

  const resetAndShowMessage = (message: string) => {
    showSnackbar(message, 'success');
    reset();
    setIsOpen(false);
    handleForm();
  };

  useEffect(() => {
    if (selectedItem) reset(selectedItem, { keepDefaultValues: true });
  }, [selectedItem]);
  return (
    <ModalComponent
      title={
        selectedItem
          ? 'Editar Contato do Telegram'
          : 'Adicionar Contato do Telegram'
      }
      onClose={handleClose}
      isOpen={isOpen}
    >
      <Grid2 container size={12} spacing={3}>
        <Grid2 display={'flex'} justifyContent={'center'} size={12}>
          <Grid2 display={'column'} size={6} justifyContent={'center'}>
            <Controller
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <TextFieldComponent
                  label="Nome"
                  onChangeText={(val) => onChange(val)}
                  type={'text'}
                  errorMessage={error?.message}
                  value={value}
                />
              )}
              name={'name'}
              control={control}
            />
            <Controller
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <TextFieldComponent
                  label="ID do Telegram"
                  onChangeText={(val) => onChange(val)}
                  type={'text'}
                  errorMessage={error?.message}
                  value={value}
                />
              )}
              name={'telegramId'}
              control={control}
            />
          </Grid2>
        </Grid2>
        <Grid2 display={'flex'} size={12}>
          <ButtonComponent
            type="submit"
            variant="contained"
            color="primary"
            loading={isLoadingCreate || isLoadingUpdate}
            fullWidth
            onClick={handleSubmit(handleEdition)}
          >
            Salvar
          </ButtonComponent>
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default TelegramIdEditionModal;
